import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class SearchService extends Service{
    constructor() {
        super();
        this.baseURL = `search`;
    }

    suggestions(phrase) {
        return fetch(SERVER_URL + this.baseURL + `/suggestions?phrase=${phrase}`, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}